<script lang="ts">
    import {authBlobUrl, authFetch} from "../Auth";
    import {addUser, UserStatus} from "../Utils";
    import AuthSource from "../Component/AuthSource.svelte";
    import AuthImage from "../Component/AuthImage.svelte";
    import type {ContactData, UserData} from "../Types";
    import Sort from "../Component/Sort.svelte";
    import {getRouteById} from "../Nav";
    import {DateTime} from "luxon";
    import throttle from "@jcoreio/async-throttle";
    import AddContactAsUserButton from "../Component/AddContactAsUserButton.svelte";
    import {strToLocaleDateTime, UserType} from "../Utils";

    export let params: {
        userId: string
        ua: string
    }
    let listPromise: Promise<any>
    let filter = {
        user_id: null,
        ua: null,
        offset: 0,
        limit: 100,
        phrase: "",
        order: "DESC",
        orderBy: "id",
    }
    filter.phrase = params.phrase ? params.phrase : ""
    $: {
        filter.user_id = params.userId
        filter.ua = params.ua ? params.ua == '1' : null
        update()
    }
    let list: ContactData[] = []
    let user: UserData
    let count: number = 0

    async function loadList() {
        let response = await authFetch('user/contacts', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            count = data.count
            user = data.user
        } else {
            alert(response.statusText)
        }
    }

    function onSort(ev: Event) {
        if (ev.detail.order === null) {
            filter.order = "DESC"
            filter.orderBy = "id"
        } else {
            filter.order = ev.detail.order
            filter.orderBy = ev.detail.orderBy
        }
        update()
    }

    function update() {
        listPromise = loadList()
    }

    let onInput = throttle(() => {
        update()
    }, 1000)

    async function exportContacts() {
        let response = await authFetch(`export/contacts`,  {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        let filename = 'export-contacts.html'

        if (response.ok) {
            let header = response.headers.get('Content-Disposition');
            let parts = header!.split(';');
            if (parts.length > 0) {
                filename = parts[1].split('=')[1];
                filename = filename.replace(/(^"|"$)/g, '').trim();
            }

            let blob = await response.blob();
            let a = document.createElement('a');
            document.body.appendChild(a);

            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            a.click();

            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }, 10)
        } else {
            alert(response.statusText)
        }
    }
    async function startSecretChat(contact:ContactData) {
        let response = await authFetch('secret-chat/start', {
            method: 'POST',
            body: JSON.stringify({
                user_id: user.id,
                contact_id: contact.id,
                telegram_user_id: user.telegram_id,
                telegram_contact_id: contact.telegram_contact_id
            }),
        })

        if (response.ok) {
            let data = await response.json()
            let message = data.message ?? 'Відповідь без повідомлення'
            alert(message)
        } else {
            let data = await response.json()
            let errorMessage = response.statusText;
            if ('message' in data && data['message'].length > 0) {
                errorMessage = data['message'];
            }
            alert(errorMessage)
        }
    }

</script>
<style>
    .ua {
        background: rgba(255, 0, 0, 0.75);
        color: white;
    }
    .table .position-sticky .bi {
        font-size: 20px;
    }
    .start-secret-chat {
        margin-left: 5px;
    }
</style>
<table class="table table-bordered table-sm">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px;">
        <tr style="border: 0px;">
            <th colspan="100">
                {#await listPromise}
                    {""}
                {:then _}
                    <div class="btn-group mb-1">
                        <div class="btn btn-sm btn-outline-secondary" style="cursor:auto;">Ціль:</div>
                        <a class="btn btn-sm btn-secondary"
                           href="#{getRouteById('User').hash(user.id)}"
                           title="{user.username ?? ''}"
                        >{user.username ?? ''}
                            {#if 'names' in user && user.names.length > 0}
                                {user.names.map((item)=>item.name).join()}
                            {/if}
                        </a>
                    </div>
                {/await}
                <div class="input-group">
                    <input class="form-control" type="search" placeholder="Ім'я / телефон / telegram_id"
                           bind:value={filter.phrase} on:keyup={onInput} on:change={onInput}>
                    {#await listPromise}
                        {""}
                    {:then _}
                        <a class="btn btn-primary"
                           href="#{getRouteById('UserContacts').hash(user.id, Object.assign({}, params, {ua: null}))}"
                           class:active={filter.ua===null}>
                            Всі
                        </a>
                        <a class="btn btn-danger"
                           href="#{getRouteById('UserContacts').hash(user.id, Object.assign({}, params, {ua: 1}))}"
                           class:active={filter.ua===true}>
                            UA
                        </a>
                        <a class="btn btn-primary"
                           href="#{getRouteById('UserContacts').hash(user.id, Object.assign({}, params, {ua: 0}))}"
                           class:active={filter.ua===false}>
                            Не UA
                        </a>
                        <button class="btn btn-success" on:click={()=>{exportContacts()}}>
                            <i class="bi bi-download"></i>
                        </button>
                    {/await}
                    <button class="btn btn-info"
                            class:disabled={filter.offset===0}
                            on:click={()=>{filter.offset-=filter.limit;update()}}>
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                           min="1"
                           max={Math.floor(count / filter.limit)+1}
                           step="1"
                           value={(filter.offset / filter.limit)+1}
                           on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                    >
                    <button class="btn btn-info disabled">
                        / {Math.floor(count / filter.limit) + 1}
                    </button>
                    <button class="btn btn-info"
                            class:disabled={list.length < filter.limit}
                            on:click={()=>{filter.offset+=filter.limit;update()}}>
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </th>
        </tr>
        <tr style="border: 0px; font-size: 14px;" class="text-nowrap">
            <th style="min-width: 70px">ID
                <Sort orderBy="id" state={filter} orders={["ASC","DESC"]} on:sort={onSort}></Sort>
            </th>
            <th>Фото</th>
            <th style:width="20%">ПІБ</th>
            <th style:width="20%">В контактах у інших цілей</th>
            <th>Username</th>
            <th>Телефон</th>
            <th>Telegram ID</th>
            <th>Контакт</th>
            <th>Взаємний контакт</th>
            <th>Тип</th>
            <th>Статус</th>
            <th>Був онлайн</th>
            <th style="min-width: 160px">Створений</th>
            <th></th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if list.length > 0}
            {#each list as contact}
                <tr>
                    <td>{contact.id}</td>
                    <td class="text-center" style="width: 100px">
                        {#if contact.small_path && contact.small_path.length > 0}
                            <AuthImage width="100" imageClass="rounded-circle" src="/user/{user.id}/contact/{contact.id}/avatar"/>
                        {/if}
                        {#if contact.attachments && contact.attachments.length > 0}
                            {#if contact.attachments[0]?.telegram_attachment_id?.length > 0 || contact.attachments[0]?.telegram_remote_attachment_id?.length > 0}
                                <AuthImage
                                        width="100"
                                        imageClass="rounded-circle"
                                        src="/user/{user.telegram_id}/contact/{contact.telegram_contact_id}/attachment/{contact.attachments[0]?.telegram_attachment_id ?? ''}/{contact.attachments[0]?.telegram_remote_attachment_id ?? '1'}"
                                />
                            {/if}
                        {/if}
                    </td>
                    <td>{contact.first_name ?? ''} {contact.last_name ?? ''}</td>
                    <td>
                        {#each contact.alts as inOtherContact}
                            {#if inOtherContact.user }
                                <a class="btn btn-sm btn-primary m-1"
                                   href="#{getRouteById('UserContacts').hash(inOtherContact.user.id)}">
                                    {inOtherContact.first_name} {inOtherContact.last_name} {inOtherContact.username}
                                    <i class="bi bi-chevron-left"></i>
                                    {inOtherContact.user?.username ?? (
                                        inOtherContact.user?.names?.length > 0 ? inOtherContact.user.names[0].name : inOtherContact.user?.telegram_id ?? '-'
                                    )}
                                </a>
                            {:else }
                                <span>{inOtherContact.first_name} {inOtherContact.last_name} {inOtherContact.username}</span>
                            {/if}
                        {/each}
                    </td>
                    <td>{contact.username ?? ''}</td>
                    <td class:ua={(contact.phone ?? '').indexOf('38')===0}>
                        {contact.phone ?? ''}
                    </td>
                    <td>{contact.telegram_contact_id ?? ''}</td>
                    <td>
                        {#if contact.is_contact == true}
                            <i class="bi bi-check text-success"></i>
                        {:else }
                            <i class="bi bi-x text-danger"></i>
                        {/if}
                    </td>
                    <td>
                        {#if contact.is_mutual_contact == true}
                            <i class="bi bi-check text-success"></i>
                        {:else }
                            <i class="bi bi-x text-danger"></i>
                        {/if}
                    </td>
                    <td>{UserType[contact.type] ?? 'без типу'}</td>
                    <td>{UserStatus[contact.status] ?? 'без типу'}</td>
                    <td>{contact.was_online ? strToLocaleDateTime(contact.was_online) : ''}</td>
                    <td>{contact.created_at ? strToLocaleDateTime(contact.created_at) : ''}</td>
                    <td class="text-nowrap">
                        <span class="btn-group">
                            {#if contact.chat}
                                <a class="btn btn-sm btn-primary"
                                   href="#{getRouteById('UserChats').hash(user.id, contact.chat.id)}">
                                    Чат
                                </a>
                                <a class="btn btn-sm btn-outline-primary"
                                   href="#{getRouteById('UserChats').hash(user.id, contact.chat.id)}">
                                    {contact.chat.total_messages}
                                </a>
                            {/if}
                            <AddContactAsUserButton {contact}/>
                            {#if contact.is_contact}
                                <button class="btn btn-sm btn-primary start-secret-chat"
                                        title="Почати секретний чат"
                                        on:click={()=>startSecretChat(contact)}>
                                    <i class="bi bi-lock-fill"></i>
                                </button>
                            {/if}
                          </span>
                    </td>
            {/each}
        {/if}
    {:catch error}
        <tr>
            <td colSpan="1000" class="text-center">
                <div class="alert alert-danger">{error}</div>
            </td>
        </tr>
    {/await}
    </tbody>
</table>
